import React from 'react';
import { WhitePaper } from './pages/WhitePaper';
import { ModalProvider } from './components/ModalContext';
export function App() {
  return <ModalProvider data-id="element-0">
      <div className="w-full min-h-screen bg-white text-gray-800 font-sans" data-id="element-1">
        <WhitePaper data-id="element-2" />
      </div>
    </ModalProvider>;
}